var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6874 14.9013V9.15409C15.6874 8.75425 15.6058 8.3586 15.4476 7.99139C15.2894 7.62418 15.0579 7.29314 14.7672 7.01855L9.35271 1.90147C9.08001 1.64365 8.71897 1.5 8.34369 1.5C7.96841 1.5 7.60736 1.64365 7.33466 1.90147L1.92016 7.01855C1.62952 7.29314 1.39799 7.62418 1.23977 7.99139C1.08155 8.3586 0.999958 8.75425 1 9.15409V14.9013C1 15.2908 1.15474 15.6644 1.43018 15.9398C1.70562 16.2153 2.0792 16.37 2.46874 16.37H14.2186C14.6082 16.37 14.9817 16.2153 15.2572 15.9398C15.5326 15.6644 15.6874 15.2908 15.6874 14.9013Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStroke);
export default __webpack_public_path__ + "static/media/home_stroke.3e9d7d3c6feac980edf5b5c36db60a5f.svg";
export { ForwardRef as ReactComponent };